import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommentService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }
  
  addCommentOnPost(obj): Observable<any> {    
    return this.http.post(this.baseUrl + 'commentsOnPost', obj);
}
addCommentOnPublish(obj): Observable<any> {    
  return this.http.post(this.baseUrl + 'commentsOnPublish', obj);
}

addLikeonComment(obj): Observable<any> {
  return this.http.post(this.baseUrl + 'commentsOnPost', obj);
}
}
